import { useQuery } from '@tanstack/react-query';
import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;

// pid -> {purchased, reviewed, open, days_left, closes_at}; null while loading.
export function useReviewWindow(productIds, enabled = true) {
  const ids = [...new Set((productIds || []).filter(Boolean))].sort();
  const { data } = useQuery({
    queryKey: ['review-window', ids.join(',')],
    queryFn: () => axios.get(`${API_URL}/api/customer/review-window`, { params: { product_ids: ids.join(',') }, withCredentials: true }).then((r) => r.data),
    enabled: enabled && ids.length > 0,
    staleTime: 0,
  });
  return data || null;
}

export const closedOn = (iso) => new Date(iso).toLocaleDateString('en-US', { month: 'short', day: 'numeric', timeZone: 'America/New_York' });
export const daysLeftText = (n) => (n == null ? '' : `${n} day${n === 1 ? '' : 's'} left`);
